export type BrandPosition = {
  brand_id: number;
  x: number;
  y: number;
};

export const gradient = [{
  color: [0, 0, 255, 1.0],
  offset: 0
}, {
  color: [0, 0, 255, 1.0],
  offset: 0.2
}, {
  color: [0, 255, 0, 1.0],
  offset: 0.45
}, {
  color: [255, 255, 0, 1.0],
  offset: 0.85
}, {
  color: [255, 0, 0, 1.0],
  offset: 1.0
}];